import { render, staticRenderFns } from "./IdQrRead.vue?vue&type=template&id=a946831c&"
import script from "./IdQrRead.vue?vue&type=script&lang=js&"
export * from "./IdQrRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports